<template lang="html">
  <div class="">
    <div v-if="loader" class="loader"></div>
  </div>
</template>

<script>
export default {
  name: 'resetcode',
  data(){
    return {
      transition: null,
      loader: false,
    }
  },
  created(){
    console.log('#Page: ResetCode');
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    this.resetUserPass();
  },
  methods: {
    resetUserPass: function(){
      this.loader = true;
      const data = {
        resetCode: this.$route.params.code,
        email: this.$route.params.email,
        role: this.$route.params.role
      };
      var formData = this.toFormData(data);
      var self = this;
      axios.post('resetcode', formData)
      .then(function (response) {
        self.loader = false;
          self.$router.push('/login');
      })
      .catch(function (error) {
        console.log(error);
      })
    },
    toFormData: function (obj){
      var form_data = new FormData();
      for (var key in obj) {
        form_data.append(key,obj[key]);
      }
      return form_data;
    }
  }
}
</script>
